import { render, staticRenderFns } from "./IndexPaperTrailVersions.vue?vue&type=template&id=fde7d838&"
import script from "./IndexPaperTrailVersions.vue?vue&type=script&lang=js&"
export * from "./IndexPaperTrailVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports